import type { Role } from '@quadro/domain';
import { plural } from '@quadro/domain';
import { Avatar } from '../../components/Avatar';
import { Options } from '../../components/Options';
import { Sheet, SheetFooter } from '../../components/Sheet';
import * as api from '../../data/api';
import { keys, useAction, useTasks } from '../../data/queries';
import { closeSheet } from '../../state/sheets';
import { useWorkspace } from '../../state/workspace';

const ROLES: [Role, string][] = [['admin', 'Administrador'], ['editor', 'Editor'], ['viewer', 'Leitor']];

/**
 * Pessoas da área. Quem entra pela Microsoft com e-mail da empresa já chega como editor;
 * os demais aguardam aprovação. O admin aprova,
 * define o papel (editor escreve, leitor só lê) e pode desativar o acesso.
 */
export function PeopleSheet() {
  const ws = useWorkspace();
  const tasks = useTasks().data ?? [];
  const update = useAction(api.updateProfile, [keys.people]);
  const pending = ws.people.filter(p => !p.active);
  const active = ws.people.filter(p => p.active);
  const openCount = (id: string) => tasks.filter(t => t.status !== 'done' && t.assigneeId === id).length;
  return (
    <Sheet onClose={closeSheet} label="Pessoas da área">
      <div className="sh-body"><h2>Pessoas da área</h2>
        <p className="muted" style={{ margin: '-8px 0 12px' }}>Quem aparece para receber tarefas. Quem entra com o e-mail da empresa já chega como editor; os demais aguardam a aprovação de um administrador.</p>
        {ws.isAdmin && pending.length > 0 && (
          <>
            <h3>Aguardando aprovação <span>{pending.length}</span></h3>
            {pending.map(p => (
              <div className="pp-row" key={p.id}><Avatar id={p.id} /><span className="nm">{p.name}<br /><span className="muted">{p.email}</span></span>
                <button className="btn" onClick={() => update(p.id, { active: true, role: 'editor' })}>Aprovar como editor</button>
                <button className="btn" onClick={() => update(p.id, { active: true, role: 'viewer' })}>Leitor</button>
              </div>
            ))}
            <h3>Equipe</h3>
          </>
        )}
        {active.map(p => (
          <div className="pp-row" key={p.id}>
            <Avatar id={p.id} />
            <span className="nm">{p.name}{p.id === ws.me.id && <span className="muted"> (você)</span>}</span>
            <span className="muted">{plural(openCount(p.id), 'tarefa', 'tarefas')}</span>
            {ws.isAdmin && p.id !== ws.me.id
              ? <>
                  <select className="pp-role" aria-label={`Papel de ${p.name}`} value={p.role} onChange={e => update(p.id, { role: e.target.value as Role })}><Options items={ROLES} /></select>
                  <button className="x-btn" title="Desativar acesso" aria-label={`Desativar ${p.name}`} onClick={() => update(p.id, { active: false })}>×</button>
                </>
              : <span className="pp-pend">{ROLES.find(r => r[0] === p.role)?.[1]}</span>}
          </div>
        ))}
        {!ws.isAdmin && pending.length > 0 && <p className="muted" style={{ marginTop: 12 }}>{plural(pending.length, 'pessoa aguarda', 'pessoas aguardam')} aprovação de um administrador.</p>}
      </div>
      <SheetFooter><span className="grow" /><button className="btn primary" onClick={closeSheet}>Pronto</button></SheetFooter>
    </Sheet>
  );
}
